import React, {FormEvent} from 'react';
import {Col, Form, FormControlProps} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface ACHPersonalNameFieldsProps {
  handleInputChange: (e: any) => void;
}

class ACHPersonalNameFields extends React.Component<ACHPersonalNameFieldsProps> {
  render() {
    return (
      <Col>
        <Form.Group style={{display: 'flex', alignItems: 'center'}}>
          <FontAwesomeIcon
            icon='address-card'
            className='fa-lg'
            style={{marginRight: '12px', maxWidth: '21px'}}
          />
          <Form.Control
            type='text'
            name='firstName'
            placeholder='First Name'
            aria-label='First Name'
            required={true}
            style={{marginRight: '12px'}}
            onChange={this.props.handleInputChange}
          />
          <Form.Control
            type='text'
            name='lastName'
            placeholder='Last Name'
            required={true}
            onChange={this.props.handleInputChange}
          />
        </Form.Group>
      </Col>
    );
  }
}

export default ACHPersonalNameFields;
